import Component from '../abstracts/Component';
import ContentExtractor from '../utils/ContentExtractor';
import VideoBrightcoveComponent from "./VideoBrightcoveComponent";

export default class HeroComponent extends Component {

  get COMPONENTNAME() {
      return 'HeroComponent';
  }

  get SELECTORS() {
    return {
      item: '[data-hph-item]',
      slider: '[data-hph-slider]',
      dotsNav: '[data-hph-dots]',
      prevSlick: '[data-hph-prev]',
      nextSlick: '[data-hph-next]',
      contentBlock: '[data-hph-content]',
      indexBlock: '[data-hph-index]',
      bcSlide: '[data-hero-bc-video]', // brightcove video slide
    };
  }
  get CSS_CLASSNAMES() {
    return {
      contentShow: 'content-show',
      contentTransition: 'content-transition',
    };
  }
  constructor(compEl) {
    super(compEl);
    this.items = [...this.$component.querySelectorAll(this.SELECTORS.item)];
    this.contents = [];
    this.slider = this.$component.querySelector(this.SELECTORS.slider);
    this.videoSlides = this.$component.querySelectorAll(this.SELECTORS.bcSlide);
    this.bcInstances = [];
    this.autoplaySpeed = 0;
    this.dotsNav = this.$component.querySelector(this.SELECTORS.dotsNav);
    this.prevSlick = this.$component.querySelector(this.SELECTORS.prevSlick);
    this.nextSlick = this.$component.querySelector(this.SELECTORS.nextSlick);
    this.contentBlock = this.$component.querySelector(this.SELECTORS.contentBlock);
    this.indexBlock = this.$component.querySelector(this.SELECTORS.indexBlock);
    this.indexTabs = [];
  }
  slickEvents() {
    this.prevSlick.addEventListener('mousedown', () => {
      this.prevSlick.classList.remove('transition');
    });
    this.prevSlick.addEventListener('click', () => {
      this.prevSlick.classList.add('transition');
    });
    this.nextSlick.addEventListener('mousedown', () => {
      this.nextSlick.classList.remove('transition');
    });
    this.nextSlick.addEventListener('click', () => {
      this.nextSlick.classList.add('transition');
    });
    $(this.slider).on('init', (e, slick) => {
      //slick init
    });
    $(this.slider).on('beforeChange', (e, slick, curr, next) => {
      try {
        this.playPauseVideoInstance(curr, false);
        this.playPauseVideoInstance(next);
      } catch (err) {
        console.log(err.stack);
      }
      // this.log('next slide: ', next);
      this.indexTabs[curr].classList.remove('active');
      //remove show class
      this.$component.classList.remove(this.CSS_CLASSNAMES.contentShow);
      //set animation class
      this.$component.classList.add(this.CSS_CLASSNAMES.contentTransition);
    });
    $(this.slider).on('afterChange', (e, slick, currentSlide) => {
      this.clearContent();
      this.prevSlick.classList.remove('transition');
      this.nextSlick.classList.remove('transition');
      try {
        this.setContentFrom(currentSlide);
        this.indexTabs[currentSlide].classList.add('active');
      } catch (err) {
        console.warn(err);
      }
    });
  }
  initSlider() {
    const customPaging = function(slider, i) {
      return $('<i class="icon-slider-bullet"></i><i class="icon-slider-bullet-active"></i>');
    };
    let dataAutoplaySpeed = +this.slider.getAttribute('data-autoplay-speed');
    this.autoplaySpeed =
      Boolean(dataAutoplaySpeed) && dataAutoplaySpeed > 2000
        ? dataAutoplaySpeed
        : 2000;
    //registering slick events before instance
    this.slickEvents();
    let opts = {
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      autoplay: true,
      autoplaySpeed: this.autoplaySpeed,
      arrows: false,
      dots: true,
      appendDots: this.dotsNav,
      infinite: true,
      swipe: false,
      draggable: false,
      customPaging: customPaging,
    };
    let slider = $(this.slider).slick(opts);
    this.prevSlick.addEventListener('click', () => {
      slider.slick('slickPrev');
    });
    this.nextSlick.addEventListener('click', () => {
      slider.slick('slickNext');
    });
    //set index tabs (desktop)
    this.setIndexTabs();
    this.indexTabs[0].classList.add('active');
  }
  setIndexTabs() {
    this.items.forEach((item, index) => {
      let label = index < 9 ? `0${index + 1}` : index + 1;
      this.indexBlock.appendChild(this.createIndexTab(label, index));
    });
  }
  createIndexTab(label, index) {
    let el = document.createElement('div');
    el.classList.add('slider-button');
    el.dataset.indexTab = index;
    el.addEventListener('click', () => {
      $(this.slider).slick('slickGoTo', index);
    });
    let numTop = document.createElement('span');
    numTop.classList.add('number-top');
    numTop.innerText = label;
    numTop.dataset.number = label;
    let numBottom = document.createElement('span');
    numBottom.classList.add('number-bottom');
    numBottom.dataset.number = label;
    numTop.appendChild(numBottom);
    el.appendChild(numTop);
    let tl = document.createElement('span');
    tl.classList.add('time-line');
    tl.style.animationDuration = `${this.autoplaySpeed / 1000}s`;
    el.appendChild(tl);
    this.indexTabs.push(el);
    return el;
  }
  setContentInstances(arrEl) {
    arrEl.forEach(element => {
      let instance = new ContentExtractor(element);
      this.contents.push(instance);
    });
  }
  setContentFrom(indexSlide) {
    // this.log('content:', indexSlide);
    //take slide data
    let content = this.contents[indexSlide];
    //set slide data into content
    content.subtitleClone && this.contentBlock.appendChild(content.subtitleClone);
    content.titleClone && this.contentBlock.appendChild(content.titleClone);
    content.bodyClone && this.contentBlock.appendChild(content.bodyClone);
    content.ctaClone && this.contentBlock.appendChild(content.ctaClone);
    //activate show class
    this.$component.classList.remove(this.CSS_CLASSNAMES.contentTransition);
    setTimeout(() => {
      this.$component.classList.add(this.CSS_CLASSNAMES.contentShow);
    }, 10);
  }
  clearContent() {
    //clear content
    this.contentBlock.innerHTML = '';
  }
  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initSlider();
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  playPauseVideoInstance(id, play = true) {
    let bcInstance = this.bcInstances.find(obj => obj.id === id);
    if (bcInstance) {
      if (play) {
        bcInstance.bcVideo.playVideo();
      } else {
        bcInstance.bcVideo.pauseVideo();
      }
    }
  }
  setBcInstances(slides) {
    slides.forEach((el, i) => {
      let obj = {};
      let slideInnerVideo = el.querySelector(this.SELECTORS.bcSlide);
      if (slideInnerVideo) {
        let instance = new VideoBrightcoveComponent(slideInnerVideo);
        instance.init();
        obj.id = i;
        obj.bcVideo = instance;
        this.bcInstances.push(obj);
      }
    });
  }

  render() {
    super.render();
    if (this.items && this.items.length > 0) {
      this.setBcInstances(this.items);
      this.setContentInstances(this.items);
      this.setContentFrom(0);
    }
    if (this.items.length > 1) {
      this.importSlick();
    } else {
      this.prevSlick.style.display = 'none';
      this.nextSlick.style.display = 'none';
    }
  }
}
